type LicenseValue = {
  id: string;
  windowPropertyName: string;
  site: string;
  email: string;
};

// TODO: CP-3226. Вынести лицензии в STRAPI
export const LICENSE: Record<string, LicenseValue> = {
  chesnok:  {
    id: '8eed8fcf-5b2b-4e28-a131-3f525e4bb4ef',
    windowPropertyName: 'anj_8eed8fcf_5b2b_4e28_a131_3f525e4bb4ef',
    site: 'chesnok.bet',
    email: 'support@chesnok.bet',
  },
  tennisi:  {
    id: '9ef0944e-0fac-4ae3-9bfc-8030c244cd25',
    windowPropertyName: 'anj_9ef0944e_0fac_4ae3_9bfc_8030c244cd25',
    site: 'tennisi.pro',
    email: 'support@tennisi.pro',
  },
};
